module.exports = __webpack_public_path__ + "295a78fb15893331a2a2d1db212e0649.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-hipster.png
// module id = 2338
// module chunks = 0